var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_vm._l((_vm.gridsX),function(x){return _c('div',{key:`${x}x`,style:(_vm.styleGridX(x))})}),_vm._l((_vm.gridsY),function(y){return _c('div',{key:`${y}y`,style:(_vm.styleGridY(y))})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }